import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { DeliveryChargeCapToolTip } from "../deliveryChargeToolTip/DeliveryChargeCapToolTip";
import { Card, Icon } from "@sellar-io/components";

export type OrderSummaryPriceProps = {
  delivery?: string;
  isDeliveryChargeCapped?: boolean;
  subTotal?: string;
  discount:
    | {
        calculatedTotal: string;
        value: string;
      }
    | undefined;
  tax: {
    name: string;
    percentage: string;
    total: string;
  };
  total: string;
  print?: boolean;
  cardContainerClassName?: string;
  hideDelivery?: boolean;
};

export const OrderSummaryPrice = (
  props: OrderSummaryPriceProps,
): ReactElement => {
  const deliveryAmount = props.delivery || "TBC";
  return (
    <Card
      className={twMerge(
        "bg-white",
        "flex flex-col gap-2 bg-neutral-100 p-4",
        !props.print && "print:hidden",
        props.cardContainerClassName && props.cardContainerClassName,
      )}
    >
      <div className={"flex justify-between"}>
        <div>Subtotal</div>
        <div>{props.subTotal}</div>
      </div>
      {!props.hideDelivery && (
        <div className={"flex justify-between"}>
          <div>Delivery</div>
          {props.isDeliveryChargeCapped ? (
            <DeliveryChargeCapToolTip>
              <div
                className={
                  "inline-flex cursor-pointer items-center gap-1 font-bold"
                }
              >
                <Icon icon={"INFORMATION_OUTLINE"} size={0.65} />
                {deliveryAmount}
              </div>
            </DeliveryChargeCapToolTip>
          ) : (
            <div>{deliveryAmount}</div>
          )}
        </div>
      )}
      {props.discount && (
        <div className={"flex justify-between"}>
          <div>Discount</div>
          <div>-{props.discount.calculatedTotal}</div>
        </div>
      )}
      <div className={"flex justify-between"}>
        <div>
          {props.tax.name}
          {props.tax.percentage ? ` (${props.tax.percentage}%)` : ""}
        </div>
        <div>{props.tax.total}</div>
      </div>
      <div className={"my-2 border-t border-neutral-200"}></div>
      <div className={"flex justify-between font-bold"}>
        <div>Order Total</div>
        <div>{props.total}</div>
      </div>
    </Card>
  );
};
